<template lang="pug">
.post-form__container
  .page-header.container.--fixed
    back-button
    a.save-button.--base-color.--underline-effect(
      @click="save(draft)"
    ) Save

  post-form-default(
    :post="post"
    :errors="errors"
    @change="onChange"
    @submit="save"
  )
</template>

<script>
import { mapMutations } from 'vuex'
import { getPostResourceMixin } from '@/mixins/postResource'
import DateHelpersMixin from '@/mixins/dateHelpers'
import Post from '@/models/Post'
import BackButton from '@/components/back-button'
import PostFormDefault from '@/components/post/default-editor/post-form--default'

const PostResourceMixin = getPostResourceMixin({
  postRequired: false,
})

export default {
  name: 'post-form',
  mixins: [DateHelpersMixin, PostResourceMixin],
  components: {
    BackButton,
    PostFormDefault,
  },
  data() {
    return {
      draft: null,
      errors: { title: '', content: '' }
    }
  },
  computed: {
    hasErrors() {
      return !!(this.errors.title || this.errors.content)
    }
  },
  methods: {
    ...mapMutations(['addPost', 'updatePost']),
    onChange(draft) {
      console.debug('onChange', draft)
      this.draft = draft
    },
    save() {
      console.debug('save', this.draft)
      this.validatePost(this.draft)
      if (this.hasErrors) return
      
      let post
      let postId = this.post.id
      if (!postId) {
        postId = Post.nextId()
        post = Object.assign(this.draft.toJson(), { id: postId })
        this.addPost(post)
      } else {
        post = Object.assign(this.draft.toJson(), { id: postId })
        this.updatePost(post)
      }

      this.$router.push({
        name: 'postById',
        params: { id: postId },
      })
    },
    validatePost(post) {
      console.debug('validatePost', post)
      let valid = true
      if (!post.title) {
        this.errors.title = 'Title Required'
        valid = false
      }
      if (!post.sections.length || !post.sections[0].content) {
        this.errors.content = 'Content Required'
        valid = false
      }
      return valid
    },
  }
}
</script>

<style lang="sass">
.post-form
  height: calc(100vh - 3rem)

.page__header
  &.--fixed
    background-image: linear-gradient(0deg, rgba(255,255,255,0), white 1.5rem, white)
    position: fixed
    top: 0;
    left: 0;
    right: 0;
    z-index: 99
    // container styles
    max-width: calc(96ch + 2rem)
    margin: 0 auto
    padding-bottom: 1rem
    
.save-button
  display: inline-block
  margin-bottom: 0.5rem
  font-size: 1rem
  font-variant: all-small-caps

  &.--underline-effect
    --underline-effect-line-height: 2px

</style>
